const localeCompareFi = (a = "", b = "") =>
  a.localeCompare(b, "fi", { sensitivity: "base" });

export function trendSeriesKey(row) {
  return [row.locationKey, row.provider, row.productName, row.fuelTypeId || "none"].join("|");
}

export function buildTrendChart(rows = []) {
  const rawSeries = new Map();

  rows.forEach((row) => {
    const key = trendSeriesKey(row);
    if (!rawSeries.has(key)) {
      const locationLabel = row.locationCode
        ? `${row.locationName} (${row.locationCode})`
        : row.locationName;
      rawSeries.set(key, {
        rawKey: key,
        label: [locationLabel, row.providerLabel, row.productName, row.fuelTypeLabel]
          .filter(Boolean)
          .join(" – "),
      });
    }
  });

  const chartSeries = [...rawSeries.values()]
    .sort((a, b) => localeCompareFi(a.label, b.label))
    .map((series, index) => ({ ...series, key: `series-${index}` }));
  const seriesKeyByRawKey = new Map(chartSeries.map((series) => [series.rawKey, series.key]));
  const dateMap = new Map();

  rows.forEach((row) => {
    const key = seriesKeyByRawKey.get(trendSeriesKey(row));
    if (!dateMap.has(row.date)) dateMap.set(row.date, { date: row.date });
    dateMap.get(row.date)[key] = row.unit_price;
  });

  return {
    chartSeries,
    chartData: [...dateMap.values()].sort((a, b) => new Date(a.date) - new Date(b.date)),
  };
}

export function buildTrendDayValues(chartData = [], chartSeries = [], date) {
  const dateValues = chartData.find((item) => item.date === date);
  if (!dateValues) return [];
  return chartSeries
    .map((series) => ({ ...series, value: dateValues[series.key] }))
    .filter((item) => Number.isFinite(item.value))
    .sort((a, b) => b.value - a.value);
}
